import { Auth } from '@nackle/bridge';
import { idURL } from './endpoints.js';
import { applyRequestMiddleware } from './fetch';

const auth = new Auth( {
    authority: idURL,
    automaticSilentRenew: false
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} )
    };

    if ( auth.state.accessToken ) {
        options.headers.authorization = `Bearer ${ auth.state.accessToken } `;
    }
} );

